__turbopack_context__.v({
  "accordionSlideOverwrite": "kindnessChallenge-module-scss-module__dfAdDW__accordionSlideOverwrite",
  "card": "kindnessChallenge-module-scss-module__dfAdDW__card",
  "cardDecoration": "kindnessChallenge-module-scss-module__dfAdDW__cardDecoration",
  "cardWrapper": "kindnessChallenge-module-scss-module__dfAdDW__cardWrapper",
  "challengeSelect": "kindnessChallenge-module-scss-module__dfAdDW__challengeSelect",
  "exploreButton": "kindnessChallenge-module-scss-module__dfAdDW__exploreButton",
  "fadeIn": "kindnessChallenge-module-scss-module__dfAdDW__fadeIn",
  "fadeOut": "kindnessChallenge-module-scss-module__dfAdDW__fadeOut",
  "fieldRow": "kindnessChallenge-module-scss-module__dfAdDW__fieldRow",
  "footer": "kindnessChallenge-module-scss-module__dfAdDW__footer",
  "form": "kindnessChallenge-module-scss-module__dfAdDW__form",
  "formItem": "kindnessChallenge-module-scss-module__dfAdDW__formItem",
  "header": "kindnessChallenge-module-scss-module__dfAdDW__header",
  "inputField": "kindnessChallenge-module-scss-module__dfAdDW__inputField",
  "inputWrapper": "kindnessChallenge-module-scss-module__dfAdDW__inputWrapper",
  "label": "kindnessChallenge-module-scss-module__dfAdDW__label",
  "loginLink": "kindnessChallenge-module-scss-module__dfAdDW__loginLink",
  "logo": "kindnessChallenge-module-scss-module__dfAdDW__logo",
  "pageWrapper": "kindnessChallenge-module-scss-module__dfAdDW__pageWrapper",
  "phoneHint": "kindnessChallenge-module-scss-module__dfAdDW__phoneHint",
  "scaleIn": "kindnessChallenge-module-scss-module__dfAdDW__scaleIn",
  "scaleOut": "kindnessChallenge-module-scss-module__dfAdDW__scaleOut",
  "scrollContainer": "kindnessChallenge-module-scss-module__dfAdDW__scrollContainer",
  "submitButton": "kindnessChallenge-module-scss-module__dfAdDW__submitButton",
  "subtitle": "kindnessChallenge-module-scss-module__dfAdDW__subtitle",
  "successIcon": "kindnessChallenge-module-scss-module__dfAdDW__successIcon",
  "successScreen": "kindnessChallenge-module-scss-module__dfAdDW__successScreen",
  "successSubtitle": "kindnessChallenge-module-scss-module__dfAdDW__successSubtitle",
  "successTitle": "kindnessChallenge-module-scss-module__dfAdDW__successTitle",
  "termsLink": "kindnessChallenge-module-scss-module__dfAdDW__termsLink",
  "termsRow": "kindnessChallenge-module-scss-module__dfAdDW__termsRow",
  "termsText": "kindnessChallenge-module-scss-module__dfAdDW__termsText",
  "title": "kindnessChallenge-module-scss-module__dfAdDW__title",
  "zoomIn": "kindnessChallenge-module-scss-module__dfAdDW__zoomIn",
  "zoomOut": "kindnessChallenge-module-scss-module__dfAdDW__zoomOut",
});
